import { defineStore } from 'pinia';
import {
  AbTestFlag,
  AbTestVariant,
  AbTestVariants,
} from 'commons/abtest/abTestFlags';

type State = {
  variants: AbTestVariants;
};

export const useAbTestStore = defineStore('abTest', {
  state: (): State => ({
    variants: {},
  }),

  getters: {
    // Undefined without an assignment: render what partners get today.
    variant:
      (state) =>
      <F extends AbTestFlag>(flag: F): AbTestVariant<F> | undefined =>
        state.variants[flag],
  },

  actions: {
    setVariants(variants: State['variants']) {
      this.variants = variants;
    },
  },
});
